import fs from 'fs'
const SYNC_TARGETS_FILE_NAME = 'sync-targets.json'

export type SyncTarget = {
  origin: string
}

export class SyncTargetManager {
  private syncTargets: SyncTarget[] = []
  private static singletonInstance: SyncTargetManager | null
  private constructor() {
    if (!fs.existsSync(SYNC_TARGETS_FILE_NAME)) {
      console.log(`${SYNC_TARGETS_FILE_NAME} does not exist, creating one now`)
      fs.writeFileSync(SYNC_TARGETS_FILE_NAME, '[]')
    }

    this.readFromFile()
  }

  static getInstance() {
    if (!this.singletonInstance) {
      this.singletonInstance = new this()
    }
    return this.singletonInstance
  }

  public getSyncTargets() {
    return this.syncTargets
  }

  public hasSyncTargets() {
    return this.syncTargets.length > 0
  }

  public static reset() {
    this.singletonInstance = null
  }

  public addSyncTarget(target: SyncTarget) {
    this.syncTargets.push(target)
    fs.writeFileSync(SYNC_TARGETS_FILE_NAME, JSON.stringify(this.syncTargets, null, 2))
  }

  private readFromFile() {
    this.syncTargets = JSON.parse(fs.readFileSync(SYNC_TARGETS_FILE_NAME).toString()) as Array<{
      origin: string
    }>
  }
}
